function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      // alert();
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.filterMedia();
      this.updateMeta();
    }
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });


  }
  updateMeta() {
    extraProductTitle(this.currentVariant.id);
    showVariantDescription(this.currentVariant.id);
    extraProductInfo(this.currentVariant.id);
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  filterMedia() {
    if (this.currentVariant.featured_media != null) {
      if (this.currentVariant.featured_media.alt === null) {
        $('.product__media-list').addClass('hidden');
        $('.product__slider-main-0').removeClass('hidden');
        $('.product__slider-thmb').addClass('hidden');
        $('.product__slider-thmb-0').removeClass('hidden');
      } else {
        var selected_variant = this.currentVariant.featured_media.alt.toLowerCase();
        var numericPart = selected_variant.split(" - ");
        var selected_attribute = '[data-color="' + numericPart[1] + '"]';
        $(selected_attribute).removeClass('hidden').siblings().addClass('hidden');
        $(selected_attribute).show();
        var curVarHTML = $(selected_attribute).html();
        $(selected_attribute).find('.var-Placeholder').hide();
        $('.thumbnail-slider').show();
        $('.product__slider-main').each(function (index) {
          //$('.product__slider-main-' + index).slick('unslick');
          //$('.product__slider-thmb-' + index).slick('unslick');         
          $('.galleryViewer').css('width', '82%');
          // mainProductSlider(index);
          $(selected_attribute).find('.var-Placeholder').hide();
        });
      }

    }
    else {
      $('.product__media-list').addClass('hidden');
      $('.product__slider-main-0').removeClass('hidden');
      $('.product__slider-thmb').addClass('hidden');
      $('.product__slider-thmb-0').removeClass('hidden');
      // var selected_variant = this.currentVariant;         
      // for (let i = 1; i <= 3; i++) {
      //   const optionKey = `option${i}`;
      //   const optionValue = selected_variant[optionKey];      
      //   if (optionValue !== null && optionValue !== undefined) {          
      //     const optionVal = optionValue.toLowerCase();                   
      //     var selected_attribute = '[data-color="' + optionVal + '"]';                
      //     $(selected_attribute).removeClass('hidden').siblings().addClass('hidden');          
      //     var curVarHTML = $(selected_attribute).html();        
      //      if (curVarHTML !== undefined) {        
      //       var varPlaceholderElement = $(curVarHTML).find('.var-Placeholder');                           
      //          varPlaceholderElement.show();      
      //          $('.product__slider-main').each(function(index) {
      //           $('.product__slider-main-' + index).slick('unslick');
      //           $('.product__slider-thmb-' + index).slick('unslick');        
      //            $('.thumbnail-slider').hide();
      //            $('.galleryViewer').css('width', '100%');
      //            mainProductSlider(index);                      
      //            $(selected_attribute).find('.var-Placeholder').show();           
      //         });              
      //       }          
      //   }
      // }
    }
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      // Update the hidden p_sku input with the new variant's SKU
      const pSkuInput = productForm.querySelector('#p_sku');
      if (pSkuInput && this.currentVariant.sku) {
        pSkuInput.value = this.currentVariant.sku;
        console.log('📦 Updated p_sku to:', this.currentVariant.sku);
      }
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected1 = inputWrappers[index - 1].querySelector(':checked');
      //  if (index === 1 && previousOptionSelected1 === null) {
      //     const errorMessage = document.createElement('span');
      //     console.log(previousOptionSelected1);
      //     console.log("Please select an option for the first input.");
      //     errorMessage.textContent = "Please select an option for the first input.";
      //     errorMessage.classList.add('error-message');
      //     inputWrappers[index].insertAdjacentElement('afterend', errorMessage);
      //     return;
      //  } 
      // else {

      // }
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections        
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        //Custome JS
        // $('.final-price').html(source.innerHTML);
        const destinationFinal = document.getElementById(`final-price-${this.dataset.section}`);
        const source2 = html.getElementById(
          `final-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const destinationSticky = document.getElementById(`sticky-price-${this.dataset.section}`);
        const source1 = html.getElementById(
          `sticky-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const destinationMeta = document.getElementById(`meta-price-${this.dataset.section}`);
        const source3 = html.getElementById(
          `meta-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        // const source1 = html.getElementById(
        //   `sticky-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        // );
        // $('.sticky-price').html(source1.innerHTML);
        // $('.meta-swatch.active').find('.color-swatch-price').html(source1.innerHTML);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source1 && destinationSticky) destinationSticky.innerHTML = source1.innerHTML;
        if (source2 && destinationFinal) destinationFinal.innerHTML = source2.innerHTML;
        if (source3 && destinationMeta) destinationMeta.innerHTML = source3.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));

          // Also update the hidden p_sku input with the new SKU value
          var skuValue = skuSource.textContent.trim().replace('SKU:', '').trim();
          var pSkuInput = document.getElementById('p_sku');
          if (pSkuInput) {
            pSkuInput.value = skuValue;
            console.log('📦 Updated p_sku to:', skuValue);
          }
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const addButtonSticky = document.querySelector('#sticky-buy-now');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      //if (text) addButtonText.textContent = text;
    } else {
      addButton.classList.remove('on_load_disable');
      if (addButtonSticky) {
        addButtonSticky.classList.remove('on_load_disable');
      }
      $('.buy-it-now-custome').removeClass('disabled');
      addButton.removeAttribute('disabled');
      // addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

//Size Guide popup
if ('.size-guide-trigger:contains(Size guide)') {
  class SizeGuideComponent extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#custom-drawer-Overlay').addEventListener('click', this.close.bind(this));
      document.addEventListener('DOMContentLoaded', () => {
        this.setHeaderCartIconAccessibility();
      });
    }

    setHeaderCartIconAccessibility() {
      const lookbookLink = document.querySelector('.size-guide-trigger');
      if (lookbookLink) {
        lookbookLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(lookbookLink);
        });
      } else {
        // console.error("Element with class 'size-guide-trigger' not found.");
      }
    }

    open(triggeredBy) {
      setTimeout(() => { this.classList.add('animate', 'active') });
      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  }

  customElements.define('size-guide-drawer', SizeGuideComponent);
}

//  new code slider

$(document).ready(function () {
  var mainSliderSelectors = document.querySelectorAll('.product__slider-main');
  var thumbSliderSelectors = document.querySelectorAll('.product__slider-thmb');

  mainSliderSelectors.forEach(function (mainSliderSelector, index) {
    var galleryThumbs = new Swiper(thumbSliderSelectors[index], {
      slidesPerView: 4,
      watchSlidesProgress: true,
      mousewheel: true,
      freeMode: true,
      breakpoints: {
        0: {
          slidesPerView: 4,
          spaceBetween: 10,
          mousewheel: false
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 10,
          freeMode: true,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 15,
          direction: 'vertical',
          navigation: {
            nextEl: '.product-thumbs-next',
            prevEl: '.product-thumbs-prev',
          },
        },
      },
    });

    var galleryMain = new Swiper(mainSliderSelector, {
      freeMode: false,
      spaceBetween: 1,
      navigation: {
        nextEl: '.product-thumb-next',
        prevEl: '.product-thumb-prev',
      },
      speed: 500,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          var slides = document.querySelectorAll('.swiper-slide');
          var hasVideoDot = slides[index].querySelector('.video-dot') !== null;

          if (hasVideoDot) {
            return '<span class="' + className + '" aria-label="Play video in gallery view">' +
              '<svg width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M0.438879 0.270387C0.438897 0.270399 0.438914 0.270412 0.438931 0.270424L4.67827 3.34121L4.67855 3.34141C4.69676 3.35456 4.71482 3.37497 4.72845 3.40307C4.74211 3.43122 4.75 3.46452 4.75 3.49957C4.75 3.53463 4.74211 3.56792 4.72845 3.59608C4.71482 3.62418 4.69676 3.64458 4.67855 3.65773L4.67825 3.65795L0.438932 6.72957C0.438874 6.72962 0.438815 6.72966 0.438756 6.7297C0.419657 6.74347 0.400621 6.74925 0.383651 6.74993C0.366687 6.75061 0.348002 6.74636 0.329061 6.73471C0.309754 6.72284 0.289863 6.70292 0.274532 6.67386C0.259173 6.64475 0.250079 6.60946 0.25 6.57196V6.57132V0.428043C0.250079 0.390543 0.259173 0.355248 0.274532 0.326138C0.289864 0.29708 0.309755 0.277161 0.329062 0.265289C0.348 0.253645 0.366684 0.24939 0.383651 0.25007C0.400662 0.250752 0.419742 0.25656 0.438879 0.270387Z" stroke="black" stroke-width="0.5"/>' +
              '</path>' +
              '</svg>' + '</span>';
          } else {
            return '<span class="' + className + '"></span>';
          }
        },
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });
  });
});

// var mq = window.matchMedia( "(max-width: 749px)" );
// if (mq.matches) {
// $(document).ready(function () {
//   var mainSliderSelectorMob = '.mobile-slider';
// var galleryMain = new Swiper(mainSliderSelectorMob, {
//   watchOverflow: true,
//   watchSlidesVisibility: true,
//   watchSlidesProgress: true,
//   preventInteractionOnTransition: true,
//   freeMode:false,
//   navigation: {
//     nextEl: '.product-thumb-next',
//     prevEl: '.product-thumb-prev',
//   },
//     speed: 500,
//     pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//         renderBullet: function (index, className) {
//           var slides = document.querySelectorAll('.swiper-slide');
//           var hasVideoDot = slides[index].querySelector('.video-dot') !== null;

//           if (hasVideoDot) {
//             return '<span class="' + className + '" aria-label="Play video in gallery view">' +
//               '<svg width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg">' +
//               '<path d="M0.438879 0.270387C0.438897 0.270399 0.438914 0.270412 0.438931 0.270424L4.67827 3.34121L4.67855 3.34141C4.69676 3.35456 4.71482 3.37497 4.72845 3.40307C4.74211 3.43122 4.75 3.46452 4.75 3.49957C4.75 3.53463 4.74211 3.56792 4.72845 3.59608C4.71482 3.62418 4.69676 3.64458 4.67855 3.65773L4.67825 3.65795L0.438932 6.72957C0.438874 6.72962 0.438815 6.72966 0.438756 6.7297C0.419657 6.74347 0.400621 6.74925 0.383651 6.74993C0.366687 6.75061 0.348002 6.74636 0.329061 6.73471C0.309754 6.72284 0.289863 6.70292 0.274532 6.67386C0.259173 6.64475 0.250079 6.60946 0.25 6.57196V6.57132V0.428043C0.250079 0.390543 0.259173 0.355248 0.274532 0.326138C0.289864 0.29708 0.309755 0.277161 0.329062 0.265289C0.348 0.253645 0.366684 0.24939 0.383651 0.25007C0.400662 0.250752 0.419742 0.25656 0.438879 0.270387Z" stroke="black" stroke-width="0.5"/>' +
//               '</path>' +
//               '</svg>' + '</span>';
//           } else {
//             return '<span class="' + className + '">' + '</span>';
//           }
//         },
//       },
// });

// });
// }else{
//   function mainProductSlider(index) {
//   var mainSliderSelector = '.product__slider-main-' + index;
//   var thumbSliderSelector = '.product__slider-thmb-' + index;
//   var prevArrowClass = 'slick-prev-' + index;
//   var nextArrowClass = 'slick-next-' + index;

//   $(mainSliderSelector).slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   infinite: false,
//   fade: false,
//   speed: 500,
//   dots: true,
//   asNavFor: thumbSliderSelector,
//   prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" tabindex="0" role="button"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.85" d="M7.887 23.5124C3.61261 19.1568 3.67843 12.1609 8.034 7.88646C12.3896 3.61207 19.3856 3.67788 23.6599 8.03345C27.9343 12.389 27.8685 19.385 23.5129 23.6594C19.1574 27.9338 12.1614 27.868 7.887 23.5124Z" fill="#D9D9D9"/><path d="M17.8685 20.0045L13.6555 15.7578L17.9478 11.5835" stroke="black" stroke-miterlimit="10"/></svg></button>',
//   nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" tabindex="0" role="button"><svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.85" d="M24.3957 24.2185C28.6701 19.8629 28.6043 12.8669 24.2487 8.59252C19.8931 4.31813 12.8972 4.38393 8.62277 8.73951C4.34838 13.0951 4.4142 20.0911 8.76978 24.3655C13.1253 28.6398 20.1213 28.574 24.3957 24.2185Z" fill="#D9D9D9"/><path d="M14.4142 20.7105L18.6272 16.4639L14.335 12.2896" stroke="black" stroke-miterlimit="10"/></svg></button>',
//    responsive: [
//       {
//         breakpoint: 749,
//         settings: {          
//           arrows: true,
//         }
//       }
//     ]
//   });
//   $(thumbSliderSelector).slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     infinite: false,
//     asNavFor: mainSliderSelector,
//     dots: false,
//     arrows: true,
//     loop: false,
//     centerMode: false,
//     focusOnSelect: true,
//     vertical:true,
//     verticalSwiping:true,
//     prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" tabindex="0" role="button"><svg width="40" height="46" viewBox="0 0 60 58" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1_989)"><ellipse cx="30" cy="29" rx="20" ry="20.125" transform="rotate(-90 30 29)" fill="white"/></g><path fill-rule="evenodd" clip-rule="evenodd" d="M28.9434 22.0077C29.2188 21.7284 29.5922 21.5714 29.9816 21.5714C30.3709 21.5714 30.7443 21.7284 31.0197 22.0077L39.3263 30.4379C39.4666 30.5754 39.5784 30.7398 39.6554 30.9216C39.7324 31.1034 39.7729 31.299 39.7746 31.4968C39.7762 31.6947 39.7391 31.8909 39.6653 32.0741C39.5914 32.2572 39.4824 32.4236 39.3445 32.5635C39.2067 32.7034 39.0427 32.8141 38.8623 32.889C38.6818 32.964 38.4884 33.0017 38.2935 32.9999C38.0985 32.9982 37.9058 32.9571 37.7267 32.879C37.5475 32.8009 37.3855 32.6874 37.25 32.5451L29.9816 25.1685L22.7131 32.5451C22.4361 32.8165 22.0652 32.9667 21.6802 32.9633C21.2952 32.9599 20.9269 32.8032 20.6547 32.5269C20.3824 32.2506 20.228 31.8768 20.2247 31.4861C20.2213 31.0954 20.3693 30.7189 20.6368 30.4379L28.9434 22.0077Z" fill="black"/><defs><filter id="filter0_d_1_989" x="0.875" y="0" width="58.25" height="58" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="4.5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.254902 0 0 0 0 0.25098 0 0 0 0 0.258824 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_989"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_989" result="shape"/></filter></defs></svg></button>',
//     nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" tabindex="0" role="button"><svg width="40" height="46" viewBox="0 0 60 58" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1_989)"><ellipse cx="30" cy="29" rx="20" ry="20.125" transform="rotate(-90 30 29)" fill="white"/></g><path fill-rule="evenodd" clip-rule="evenodd" d="M28.9434 22.0077C29.2188 21.7284 29.5922 21.5714 29.9816 21.5714C30.3709 21.5714 30.7443 21.7284 31.0197 22.0077L39.3263 30.4379C39.4666 30.5754 39.5784 30.7398 39.6554 30.9216C39.7324 31.1034 39.7729 31.299 39.7746 31.4968C39.7762 31.6947 39.7391 31.8909 39.6653 32.0741C39.5914 32.2572 39.4824 32.4236 39.3445 32.5635C39.2067 32.7034 39.0427 32.8141 38.8623 32.889C38.6818 32.964 38.4884 33.0017 38.2935 32.9999C38.0985 32.9982 37.9058 32.9571 37.7267 32.879C37.5475 32.8009 37.3855 32.6874 37.25 32.5451L29.9816 25.1685L22.7131 32.5451C22.4361 32.8165 22.0652 32.9667 21.6802 32.9633C21.2952 32.9599 20.9269 32.8032 20.6547 32.5269C20.3824 32.2506 20.228 31.8768 20.2247 31.4861C20.2213 31.0954 20.3693 30.7189 20.6368 30.4379L28.9434 22.0077Z" fill="black"/><defs><filter id="filter0_d_1_989" x="0.875" y="0" width="58.25" height="58" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="4.5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.254902 0 0 0 0 0.25098 0 0 0 0 0.258824 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_989"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_989" result="shape"/></filter></defs></svg></button>'
//   });

//   $(mainSliderSelector).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
//    	var mySlideNumber = nextSlide;    
//    	$(thumbSliderSelector).find('.slick-slide').removeClass('slick-current');
//    	$(thumbSliderSelector).find('.slick-slide').eq(mySlideNumber).addClass('slick-current');
//   });
//   $(window).resize();
// }
// $(document).ready(function () {
//   $('.product__slider-main').each(function(index, sliderElement) {
//     mainProductSlider(index);
//     var slideCount = $(sliderElement).find('.slick-slide').length;
//     if (slideCount > 1) {
//       $(sliderElement).find('.slick-slide').each(function(slideIndex, slideElement) {
//         if ($(slideElement).hasClass('var-Placeholder')) {
//           var slickInstance = $(sliderElement).slick('getSlick');
//           slickInstance.slickRemove(slideIndex);
//         }
//       });
//     }
//   });
// });
// }



// $(document).ready(function () {
//   var mainSliderSelector = '.product__slider-main';
// var thumbSliderSelector = '.product__slider-thmb';
// var galleryMain = new Swiper(mainSliderSelector, {
//   watchOverflow: true,
//   watchSlidesVisibility: true,
//   watchSlidesProgress: true,
//   preventInteractionOnTransition: true,
//   freeMode:false,
//   navigation: {
//     nextEl: '.product-thumb-next',
//     prevEl: '.product-thumb-prev',
//   },
//     speed: 500,
//     pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//         renderBullet: function (index, className) {
//           var slides = document.querySelectorAll('.swiper-slide');
//           var hasVideoDot = slides[index].querySelector('.video-dot') !== null;

//           if (hasVideoDot) {
//             return '<span class="' + className + '" aria-label="Play video in gallery view">' +
//               '<svg width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg">' +
//               '<path d="M0.438879 0.270387C0.438897 0.270399 0.438914 0.270412 0.438931 0.270424L4.67827 3.34121L4.67855 3.34141C4.69676 3.35456 4.71482 3.37497 4.72845 3.40307C4.74211 3.43122 4.75 3.46452 4.75 3.49957C4.75 3.53463 4.74211 3.56792 4.72845 3.59608C4.71482 3.62418 4.69676 3.64458 4.67855 3.65773L4.67825 3.65795L0.438932 6.72957C0.438874 6.72962 0.438815 6.72966 0.438756 6.7297C0.419657 6.74347 0.400621 6.74925 0.383651 6.74993C0.366687 6.75061 0.348002 6.74636 0.329061 6.73471C0.309754 6.72284 0.289863 6.70292 0.274532 6.67386C0.259173 6.64475 0.250079 6.60946 0.25 6.57196V6.57132V0.428043C0.250079 0.390543 0.259173 0.355248 0.274532 0.326138C0.289864 0.29708 0.309755 0.277161 0.329062 0.265289C0.348 0.253645 0.366684 0.24939 0.383651 0.25007C0.400662 0.250752 0.419742 0.25656 0.438879 0.270387Z" stroke="black" stroke-width="0.5"/>' +
//               '</path>' +
//               '</svg>' + '</span>';
//           } else {
//             return '<span class="' + className + '">' + '</span>';
//           }
//         },
//       },
//      thumbs: {
//     swiper: galleryThumbs
//   }
// });
//   var galleryThumbs = new Swiper(thumbSliderSelector, {
//   centeredSlides: true,
//   centeredSlidesBounds: true,
//   slidesPerView: 4,
//   watchOverflow: true,
//   watchSlidesVisibility: true,
//   watchSlidesProgress: true,
//    freeMode:true,
//   direction: 'vertical',
//     navigation: {
//     nextEl: '.thumbnail-next',
//     prevEl: '.thumbnail-prev',
//   },
// });
// });

// function mainProductSlider(index) {
//   var mainSliderSelector = '.product__slider-main-' + index;
//   var thumbSliderSelector = '.product__slider-thmb-' + index;
//   var prevArrowClass = 'slick-prev-' + index;
//   var nextArrowClass = 'slick-next-' + index;

//   $(mainSliderSelector).slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   infinite: false,
//   fade: false,
//   speed: 500,
//   dots: true,
//   asNavFor: thumbSliderSelector,
//   prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" tabindex="0" role="button"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.85" d="M7.887 23.5124C3.61261 19.1568 3.67843 12.1609 8.034 7.88646C12.3896 3.61207 19.3856 3.67788 23.6599 8.03345C27.9343 12.389 27.8685 19.385 23.5129 23.6594C19.1574 27.9338 12.1614 27.868 7.887 23.5124Z" fill="#D9D9D9"/><path d="M17.8685 20.0045L13.6555 15.7578L17.9478 11.5835" stroke="black" stroke-miterlimit="10"/></svg></button>',
//   nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" tabindex="0" role="button"><svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.85" d="M24.3957 24.2185C28.6701 19.8629 28.6043 12.8669 24.2487 8.59252C19.8931 4.31813 12.8972 4.38393 8.62277 8.73951C4.34838 13.0951 4.4142 20.0911 8.76978 24.3655C13.1253 28.6398 20.1213 28.574 24.3957 24.2185Z" fill="#D9D9D9"/><path d="M14.4142 20.7105L18.6272 16.4639L14.335 12.2896" stroke="black" stroke-miterlimit="10"/></svg></button>',
//    responsive: [
//       {
//         breakpoint: 749,
//         settings: {          
//           arrows: true,
//         }
//       }
//     ]
//   });
//   $(thumbSliderSelector).slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     infinite: false,
//     asNavFor: mainSliderSelector,
//     dots: false,
//     arrows: true,
//     loop: false,
//     centerMode: false,
//     focusOnSelect: true,
//     vertical:true,
//     verticalSwiping:true,
//     prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" tabindex="0" role="button"><svg width="40" height="46" viewBox="0 0 60 58" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1_989)"><ellipse cx="30" cy="29" rx="20" ry="20.125" transform="rotate(-90 30 29)" fill="white"/></g><path fill-rule="evenodd" clip-rule="evenodd" d="M28.9434 22.0077C29.2188 21.7284 29.5922 21.5714 29.9816 21.5714C30.3709 21.5714 30.7443 21.7284 31.0197 22.0077L39.3263 30.4379C39.4666 30.5754 39.5784 30.7398 39.6554 30.9216C39.7324 31.1034 39.7729 31.299 39.7746 31.4968C39.7762 31.6947 39.7391 31.8909 39.6653 32.0741C39.5914 32.2572 39.4824 32.4236 39.3445 32.5635C39.2067 32.7034 39.0427 32.8141 38.8623 32.889C38.6818 32.964 38.4884 33.0017 38.2935 32.9999C38.0985 32.9982 37.9058 32.9571 37.7267 32.879C37.5475 32.8009 37.3855 32.6874 37.25 32.5451L29.9816 25.1685L22.7131 32.5451C22.4361 32.8165 22.0652 32.9667 21.6802 32.9633C21.2952 32.9599 20.9269 32.8032 20.6547 32.5269C20.3824 32.2506 20.228 31.8768 20.2247 31.4861C20.2213 31.0954 20.3693 30.7189 20.6368 30.4379L28.9434 22.0077Z" fill="black"/><defs><filter id="filter0_d_1_989" x="0.875" y="0" width="58.25" height="58" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="4.5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.254902 0 0 0 0 0.25098 0 0 0 0 0.258824 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_989"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_989" result="shape"/></filter></defs></svg></button>',
//     nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" tabindex="0" role="button"><svg width="40" height="46" viewBox="0 0 60 58" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1_989)"><ellipse cx="30" cy="29" rx="20" ry="20.125" transform="rotate(-90 30 29)" fill="white"/></g><path fill-rule="evenodd" clip-rule="evenodd" d="M28.9434 22.0077C29.2188 21.7284 29.5922 21.5714 29.9816 21.5714C30.3709 21.5714 30.7443 21.7284 31.0197 22.0077L39.3263 30.4379C39.4666 30.5754 39.5784 30.7398 39.6554 30.9216C39.7324 31.1034 39.7729 31.299 39.7746 31.4968C39.7762 31.6947 39.7391 31.8909 39.6653 32.0741C39.5914 32.2572 39.4824 32.4236 39.3445 32.5635C39.2067 32.7034 39.0427 32.8141 38.8623 32.889C38.6818 32.964 38.4884 33.0017 38.2935 32.9999C38.0985 32.9982 37.9058 32.9571 37.7267 32.879C37.5475 32.8009 37.3855 32.6874 37.25 32.5451L29.9816 25.1685L22.7131 32.5451C22.4361 32.8165 22.0652 32.9667 21.6802 32.9633C21.2952 32.9599 20.9269 32.8032 20.6547 32.5269C20.3824 32.2506 20.228 31.8768 20.2247 31.4861C20.2213 31.0954 20.3693 30.7189 20.6368 30.4379L28.9434 22.0077Z" fill="black"/><defs><filter id="filter0_d_1_989" x="0.875" y="0" width="58.25" height="58" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="4.5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.254902 0 0 0 0 0.25098 0 0 0 0 0.258824 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_989"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_989" result="shape"/></filter></defs></svg></button>'
//   });

//   $(mainSliderSelector).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
//    	var mySlideNumber = nextSlide;    
//    	$(thumbSliderSelector).find('.slick-slide').removeClass('slick-current');
//    	$(thumbSliderSelector).find('.slick-slide').eq(mySlideNumber).addClass('slick-current');
//   });
//   $(window).resize();
// }
// $(document).ready(function () {
//   // Call the initProductSliders function for each pair of sliders
//   $('.product__slider-main').each(function(index, sliderElement) {
//     mainProductSlider(index);
//     var slideCount = $(sliderElement).find('.slick-slide').length;
//     if (slideCount > 1) {
//       // Iterate through each slide
//       $(sliderElement).find('.slick-slide').each(function(slideIndex, slideElement) {
//         // Check if the slide contains the "varplaceholder" class
//         if ($(slideElement).hasClass('var-Placeholder')) {
//           var slickInstance = $(sliderElement).slick('getSlick');
//           slickInstance.slickRemove(slideIndex);
//         }
//       });
//     }
//   });
// });

// Wait for the DOM to be loaded

$(document).ready(function () {
  // Get the button element
  var viewSimilarButton = $('.view-similar');

  // Get the popup element
  var similarProductPopup = $('.section-similar-popup');
  var similarNewPopup = $('.similar-popup-bg');
  // Add click event listener to the button
  viewSimilarButton.on('click', function () {
    // Toggle the visibility of the popup
    similarProductPopup.toggle();
    similarNewPopup.show();
    $('.similar-same-products').css('display', 'none'); // Initially hide the products
    $('.lod-padd').css('display', 'block');
    setTimeout(function () {
      $('.lod-padd').css('display', 'none'); // Remove loader class
      $('.similar-same-products').css('display', 'block'); // Show the products
    }, 1000);
    $("body").addClass('hide-overflow-view');
  });

});


function closeSimilar() {
  var similarProductPopup = document.querySelector('.similar-popup-bg');
  var similarNewPopup = document.querySelector('.section-similar-popup');
  $("body").removeClass('hide-overflow-view');
  similarProductPopup.style.display = 'none';
  similarNewPopup.style.display = 'none';
}

new Swiper(".color-slider", {
  slidesPerView: 3.5,
  freeMode: true,
  rewind: false,
  spaceBetween: 0,
  navigation: {
    nextEl: '.color-swatch-next',
    prevEl: '.color-swatch-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: true,
  },
  breakpoints: {
    750: {
      rewind: false,
      slidesPerView: 2,
      spaceBetween: 0,
    },
    1025: {
      rewind: false,
      slidesPerView: 2.6,
      spaceBetween: 0,
    },
    1200: {
      rewind: false,
      slidesPerView: 4,
      spaceBetween: 0,
    },
    1500: {
      rewind: false,
      slidesPerView: 4,
      spaceBetween: 0,
    },
  },
});
new Swiper(".color-slider-1", {
  slidesPerView: 3.5,
  freeMode: true,
  rewind: false,
  spaceBetween: 0,
  navigation: {
    nextEl: '.color-swatch-next-1',
    prevEl: '.color-swatch-prev-1',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: true,
  },
  breakpoints: {
    750: {
      rewind: false,
      slidesPerView: 2,
      spaceBetween: 0,
    },
    1025: {
      rewind: false,
      slidesPerView: 2.6,
      spaceBetween: 0,
    },
    1200: {
      rewind: false,
      slidesPerView: 4,
      spaceBetween: 0,
    },
    1500: {
      rewind: false,
      slidesPerView: 4,
      spaceBetween: 0,
    },
  },
});
new Swiper(".travel-slider", {
  slidesPerView: 3.5,
  freeMode: true,
  rewind: false,
  spaceBetween: 0,
  navigation: {
    nextEl: '.travel-swatch-next',
    prevEl: '.travel-swatch-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: true,
  },
  breakpoints: {
    750: {
      rewind: false,
      slidesPerView: 2,
      spaceBetween: 0,
    },
    1025: {
      rewind: false,
      slidesPerView: 2.6,
      spaceBetween: 0,
    },
    1200: {
      rewind: false,
      slidesPerView: 4,
      spaceBetween: 0,
    },
    1500: {
      rewind: false,
      slidesPerView: 4,
      spaceBetween: 0,
    },
  },
});
const windowWidth = window.innerWidth;
const breakpoint = 750;
if (windowWidth < breakpoint) {
  new Swiper(".size-slider", {
    slidesPerView: 4,
    freeMode: true,
    rewind: false,
    spaceBetween: 5,
    navigation: {
      nextEl: '.size-swatch-next-1',
      prevEl: '.size-swatch-prev-1',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: true,
    },
    breakpoints: {
      0: {
        rewind: false,
        slidesPerView: 2.2,
        spaceBetween: 5,
      },
      750: {
        rewind: false,
        slidesPerView: 3,
        spaceBetween: 5,
      },
      1025: {
        rewind: false,
        slidesPerView: 4,
        spaceBetween: 5,
      },
      1200: {
        rewind: false,
        slidesPerView: 4,
        spaceBetween: 5,
      },
      1500: {
        rewind: false,
        slidesPerView: 4,
        spaceBetween: 5,
      },
    },
  });
}

$(document).ready(function () {
  const localCode = localStorage.getItem("pincode_val");
  if (localCode != '') {
    $(".pincode_value").val(localCode);
  }

  var url = window.location.href;
  if (window.location.href.indexOf("?variant=") > -1) {
    //alert("your url contains the name franky");
    var prdocut_title = $('.product-data').attr('data-product-title');
    var prdocut_alt = $('.product-data').attr('data-onload-image-alt');
    if (prdocut_title == prdocut_alt) {
      $('.product-data').show();
      $('.variant-data').hide();
    } else {
      //console.log($('#default-variant').attr('data-image-alt'));
      //console.log('image-alt');
      //var default_variant = $('#default-variant').attr('data-variant');
      if ($('#default-variant').attr('data-variant') == 'Default Title' || $('#default-variant').attr('data-image-alt') == '') {
        $('.product-data').show();
        $('.variant-data').hide();
      } else {
        $('.product-data').hide();
        $('.variant-data').show();
      }

    }

  } else {
    $('.variant-data').hide();
  }
  //  $('.change-value').click(function() {
  //     //alert('sid');
  //     $('.product-data').hide();
  //     $('.variant-data').show();
  // });
});


// pincode

// var pincode_val = $(".pincode_value").val();
// if (pincode_val == '') {
//   $('.product_order_text').html('Please enter pincode').css("color", "red");
//  $('.product-form__submit').attr('disabled', "true");
//    $('#checkout').attr('disabled', "true");
// }else{
//   $('.product-form__submit').removeAttr('disabled', "true");
//    $('#checkout').removeAttr('disabled', "true");
// }




// go to cart code
$(document).ready(function () {
  // Listen for click events on each "Add to Cart" button

  //  $('.atc-go-cart , .wishlist-add-to-cart-btn').each(function() {
  //     var $button = $(this); // Save reference to the button
  //     var $addToCartForm = $button.closest('form');
  //     var storedMaxQuantity = localStorage.getItem('maxQuantity');
  //     $button.each(function() {
  //       var $thisButton = $(this);
  //       if (storedMaxQuantity) {
  //             $thisButton.closest('form').find('.quantity__input-home').attr('max', storedMaxQuantity);
  //         }
  //     });
  //     $button.on('click', function(e) {
  //       e.preventDefault();
  //       var formData = $addToCartForm.serialize(); // Serialize form data
  //       $addToCartForm.each(function() {
  //       var productId = $(this).find('.product-variant-id').val();
  //       var quantityInCart = getQuantityInCart(productId);
  //         // You can perform actions with productId and quantityInCart here
  //           console.log('Product ID:', productId, 'Quantity in Cart:', quantityInCart);
  //         //var qty = $addToCartForm.find('.quantity__input').val();
  //         $addToCartForm.find('.quantity__input-home').each(function() {
  //           var qty = $(this).val(); // Get the value of each quantity input
  //           console.log(qty); // Log or use the quantity value for each input as needed
  //           var varintsAvailble = $('.option-box input[type="radio"]').length > 0;
  //           var cartQuantity = $(this).attr('data-cart-quantity');
  //           var maxQuantity = $(this).attr('data-max');
  //           if (cartQuantity === maxQuantity) {
  //             handleConfirmClick(formData, $button);
  //               return;
  //             }else{
  //                 if (quantityInCart > 0) {
  //               // If the product is already in the cart, show a confirmation popup
  //               showConfirmationPopup(quantityInCart, formData, $button);
  //               } else {
  //                   // If the product is not in the cart, proceed to add it directly
  //                   addToCart(formData, $button);
  //                 //alert('no-variant');
  //               }
  //           }
  //         });
  //       });
  // });

  $(document).on('click', '.atc-go-cart, .wishlist-add-to-cart-btn', function (e) {
    e.preventDefault();


    const $button = $(this);
    const $form = $button.closest('form');

    const formData = $form.serialize();
    const productId = $form.find('.product-variant-id').val();
    const qty = Number($form.find('.quantity__input-home').val());


    // ✅ Always read fresh Shopify cart
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {

        const match = cart.items.find(i => Number(i.id) === Number(productId));
        const quantityInCart = match ? match.quantity : 0;

        const maxQuantity = Number($form.find('.quantity__input-home').attr('data-max')) || Infinity;


        if (quantityInCart >= maxQuantity) {
          handleConfirmClick(formData, $button);
          return;
        }

        if (quantityInCart > 0) {
          showConfirmationPopup(quantityInCart, formData, $button);
        } else {
          addToCart(formData, $button);
        }

      });

  });

  // Function to handle confirmation popup
  function handleConfirmClick() {
    // Hide the confirmation popup
    $('.popup-confirm').hide();
    var cartQuantity = $button.closest('form').find('.quantity__input-home').attr('data-cart-quantity');
    var maxQuantity = $button.closest('form').find('.quantity__input-home').attr('data-max');
    // Update the quantity to add 1
    var qty = $('.quantity__input-home').val();
    if (cartQuantity === maxQuantity) {
      // var $body = $('body');
      //  var $variantPopup = $body.find('.variant-popup.new-v');
      //  $variantPopup.appendTo($($button).parent());
      //  $variantPopup.removeClass('new-v');
      $('.qty-zero').show();
      setTimeout(function () {
        $('.qty-zero').hide();
      }, 2000);
      return;
    }

    // If quantity is not 0, proceed to add to cart
    addToCart(formData, $button);
  }
  // Function to show the confirmation popup
  function showConfirmationPopup(quantityInCart, formData, $button) {
    // Show the confirmation popup
    $('.popup-confirm').show();

    // Define the click handlers outside the function
    function handleConfirmClick() {
      // Hide the confirmation popup
      $('.popup-confirm').hide();

      // Update the quantity to add 1
      //formData.quantity = quantityInCart + 1;
      // Update the quantity to add 1
      var cartQuantity = $button.closest('form').find('.quantity__input-home').attr('data-cart-quantity');
      var maxQuantity = $button.closest('form').find('.quantity__input-home').attr('data-max');
      var qty = $('.quantity__input-home').val();
      if (cartQuantity === maxQuantity) {
        $('.qty-zero').show();
        // var $body = $('body');
        //   var $variantPopup = $body.find('.variant-popup.new-v');
        //   $variantPopup.appendTo($($button).parent());
        //   $variantPopup.removeClass('new-v');
        setTimeout(function () {
          $('.qty-zero').hide();
        }, 2000);
        return;
      }
      // Add to cart
      addToCart(formData, $button);
      //alert(addToCart);
    }

    function handleCancelClick() {
      // Hide the confirmation popup
      $('.popup-confirm').hide();
    }

    // Remove any existing click handlers before adding new ones
    $('.confirm').off('click').one('click', handleConfirmClick);
    $('.cancel').off('click').one('click', handleCancelClick);
  }
  // Function to make AJAX request to get the quantity of a product in the cart
  function getQuantityInCart(productId) {
    // Perform an AJAX request to get cart information
    var quantity = 0;
    $.ajax({
      type: 'GET',
      url: '/cart.js', // Shopify's cart API endpoint
      dataType: 'json',
      async: false, // Ensure synchronous behavior to get quantity before proceeding
      success: function (response) {
        // Check if the product exists in the cart
        var items = response.items;
        for (var i = 0; i < items.length; i++) {
          if (items[i].id == productId) {
            quantity = items[i].quantity;
            //alert(quantity);
            break;
          }
        }
      },
      error: function (XMLHttpRequest, textStatus) {
      }
    });
    return quantity;
  }
  // 🆕 FIX: Assign to window to make globally accessible for variant popups
  window.addToCart = function addToCart(formData, $button) {
    // 🆕 FIX: Try multiple selectors to find quantity input
    var $form = $button.closest('form');
    var qty = $form.find('.quantity__input-home').val()
      || $form.find('.quantity__input').val()
      || $form.find('input[name="quantity"]').val()
      || 1; // Default to 1 if not found

    var maxQuantity = parseInt($form.find('.quantity__input-home').attr('data-max')
      || $form.find('.quantity__input').attr('data-max')
      || $form.find('input[name="quantity"]').attr('data-max'));


    // Validate quantity
    if (!qty || isNaN(qty) || qty < 1) {
      qty = 1;
    }

    // ----------- Helpers for browser + OS + IP -----------

    function getBrowserInfo() {
      var ua = navigator.userAgent;
      var tem;
      var M = ua.match(/(opera|chrome|safari|firefox|edge|trident(?=\/))\/?\s*([\d\.]+)/i) || [];

      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+([\d\.]+)/g.exec(ua) || [];
        return "IE " + (tem[1] || "");
      }

      if (M[1] === "Chrome") {
        tem = ua.match(/\b(OPR|Edg)\/([\d\.]+)/);
        if (tem != null)
          return tem[1].replace("OPR", "Opera").replace("Edg", "Edge") + " " + tem[2];
      }

      M = M.length >= 3 ? M : [null, navigator.appName, navigator.appVersion, "-?"];
      tem = ua.match(/version\/([\.\d]+)/i);
      if (tem != null) M[2] = tem[1];

      return M[1] + " " + M[2];
    }

    function getDeviceOS() {
      var ua = navigator.userAgent;

      if (/windows/i.test(ua)) return "WINDOWS";
      if (/macintosh|mac os x/i.test(ua)) return "MAC";
      if (/iphone|ipad|ipod/i.test(ua)) return "IPHONE";
      if (/android/i.test(ua)) return "ANDROID";
      if (/linux/i.test(ua)) return "LINUX";

      return "UNKNOWN";
    }

    function getUserIP(callback) {
      $.get("https://api.ipify.org?format=json", function (response) {
        callback(response.ip);
      });
    }


    $.ajax({
      type: 'POST',
      url: '/cart/add.js', // Shopify's cart API endpoint
      data: formData + '&quantity=' + qty, // 🆕 FIX: Added = sign
      dataType: 'json',
      success: function (response) {
        // Update cart count in the header
        setTimeout(function () {
          $.getJSON('/cart.js', function (cart) {
            $("span.cart-count").html(cart.item_count);
            $(".cart-count-bubble").show();

            // Sync full cart to external API
            var DuckDuckURL = 'https://ddbadmin.duckduckbaby.in/api/';
            // Try to get email from global variable (set by Liquid), fallback to input field
            var customeremail = (typeof customerEmail !== 'undefined' ? customerEmail : null) || $('#p_mail').val() || '';


            $.ajax({
              type: 'POST',
              url: DuckDuckURL + 'storecart',
              data: {
                data: cart.items,
                customerEmail: customeremail
              },
              beforeSend: function (xhr) {
              },
              success: function (data, textStatus, xhr) {
                if (data && data.message) {
                }
                if (data && data.status) {
                }
              },
              error: function (xhr, status, error) {
              }
            });

          });
        }, 100);

        // 🆕 FIX: Get data from the button's form, not from main page
        var $form = $button.closest('form');
        var formId = $form.attr('id') || 'unknown';
        var DuckDuckURL = 'https://ddbadmin.duckduckbaby.in/api/';

        var isQuickaddForm = formId.includes('quickadd');


        // 🆕 IMPROVED: If it's a quickadd form, search specifically within that form
        var producttitle, sku, dynamicPrice, VariantId;

        if (isQuickaddForm) {

          // For quickadd, find inputs within the specific modal
          var $inputs = $form.find('input[type="hidden"]');

          // Log all hidden inputs for debugging
          $inputs.each(function (index) {
            var $input = $(this);
          });

          producttitle = $form.find('input[id="p_title"]').val() || '';
          sku = $form.find('input[id="p_sku"]').val() || '';
          dynamicPrice = $form.find('input[id="p_price"]').val() || 0;
          VariantId = $form.find('.product-variant-id').val() || '';

        } else {

          producttitle = $('#p_title').val() || '';
          sku = $('#p_sku').val() || '';
          dynamicPrice = $('#p_price').val() || 0;
          VariantId = $('.product-variant-id').val() || '';
        }

        // Remove commas from price if present 
        if (dynamicPrice && typeof dynamicPrice === 'string') {
          dynamicPrice = parseFloat(dynamicPrice.replace(/,/g, '')) || 0;
        }

        // Customer info (these are global, so always from main page)
        var customername = $('#p_name').val();
        var customeremail = $('#p_mail').val();
        var customermobileno = $('#p_phone').val();
        var sessionid = $('#p_id').val();
        var browserId = $('#browserID').val();
        var action = "Add";


        // Now fetch IP → build OS + Browser info → send API
        var browserInfo = getBrowserInfo();   // Example: "Chrome 126"
        var deviceOS = getDeviceOS();         // Example: "MAC"

        getUserIP(function (ipAddress) {

          var os_version = browserInfo + " - " + ipAddress;
          var device_detail = deviceOS + " " + browserInfo;

          // ---------- CALL DDB API ----------
          console.log('📊 [global.js - addToCart] Sending to storeNewCartDataInCsvfile:');
          console.log('📊 Data payload:', {
            sku: sku,
            customername: customername,
            customeremail: customeremail,
            customermobileno: customermobileno,
            sessionid: sessionid,
            action: action,
            browserId: browserId,
            producttitle: producttitle,
            price: dynamicPrice,
            channel: 'Web',
            os_version: os_version,
            device_detail: device_detail,
            cart_item: response
          });
          $.ajax({
            type: 'POST',
            url: DuckDuckURL + "storeNewCartDataInCsvfile",
            data: {
              'sku': sku,
              'customername': customername,
              'customeremail': customeremail,
              'customermobileno': customermobileno,
              'sessionid': sessionid,
              'action': action,
              'browserId': browserId,
              'producttitle': producttitle,

              // NEW PARAMETERS
              'price': dynamicPrice,
              'channel': "Web",
              'os_version': os_version,
              'device_detail': device_detail,
              // Single line item from Shopify add response
              'cart_item': JSON.stringify(response)
            },
            dataType: "json",
            success: function (res) {
            }
          });
        });
        // ✅ Add class to indicate button is processing/hidden
        $button.addClass('btn-processing').removeClass('btn-visible');
        console.log('🔴 [Button State] ADD TO CART button hidden - processing');

        // Hide the button
        $button.hide();

        // Calculate the new value for data-cart-quantity
        var quantityInCart = parseInt($button.closest('form').find('.quantity__input-home').attr('data-cart-quantity'));
        var newCartQuantity = quantityInCart + 1; // Increment data-cart-quantity by 1

        $button.closest('form').find('.quantity__input-home').attr('data-cart-quantity', newCartQuantity);

        // Calculate the new value for the max attribute
        var newMaxQuantity = maxQuantity - newCartQuantity;

        // Update the input's max attribute to the new value
        $button.closest('form').find('.quantity__input-home').attr('max', newMaxQuantity);
        localStorage.setItem('maxQuantity', newMaxQuantity);
        // Alert the newCartQuantity
        // Update the input's min attribute to 0 if max is 0
        if (newMaxQuantity === 0) {
          $button.closest('form').find('.quantity__input-home').attr('min', 0);
          $button.closest('form').find('.quantity__input-home').val(0);
        }



         // ✅ FIX: After a successful add-to-cart, switch UI from "Add to cart" → "Go to cart"
        setTimeout(function () {
          $button.each(function () {
            var $thisButton = $(this);

            // ----- CASE 1: Homepage cards using `.cart-link-home` as a sibling -----
            var $homeGoToCart = $thisButton.prev('.cart-link-home');
            if ($homeGoToCart.length) {
              if ($thisButton.is(':hidden')) {
                $homeGoToCart.addClass('btn-added-to-cart').removeClass('btn-hidden').show();
                console.log('🟢 [Button State] GO TO CART link (home) visible');
              } else {
                $homeGoToCart.addClass('btn-hidden').removeClass('btn-added-to-cart').hide();
                console.log('🔵 [Button State] GO TO CART link (home) hidden');
              }
            }

            // ----- CASE 2: PDP layout using section‑scoped classes (go-to-cart-SECTIONID) -----
            var btnClasses = $thisButton.attr('class') || '';
            var sectionMatch = btnClasses.match(/go-to-cart-([^\s]+)/);
            if (sectionMatch && sectionMatch[1]) {
              var sid = sectionMatch[1];

              // Main PDP buttons
              $('.submit-go-cart-' + sid).hide();
              $('.cart-link-' + sid).show();

              // Sticky bar buttons (if present)
              $('.sticky-buy-now-' + sid).hide();
              $('.cart-link-sticky-' + sid).show();

              console.log('🟢 [Button State] PDP Add→Go to cart toggled for section', sid);
            }
          });
        }, 100); // small delay for smooth DOM updates



        $('.success-item-bg').show();
        setTimeout(function () {
          $('.success-item-bg').hide();
        }, 3000);
      },
      error: function (XMLHttpRequest, textStatus, errorThrown) {
        // $('.qty-zero').show();
        //     setTimeout(function() {
        //         $('.qty-zero').hide();
        //     }, 2000);
        //     return;
      }
    });
  }
});

// =====================================================================
// 🆕 NEW CODE: Sync cart to external API when variant products are added
// This handles the case when products with variants are added via quick-add-modal
// The product-form publishes a cartUpdate event which we listen to here
// =====================================================================
$(document).ready(function () {

  // Check if subscribe function exists (from pubsub.js)
  if (typeof subscribe === 'undefined') {
    return;
  }


  // 🛡️ DEDUPLICATION: Track recently synced variants to prevent duplicates
  var recentlySyncedVariants = {};
  var DEDUPE_WINDOW_MS = 3000; // 3 seconds


  // Subscribe to cart update events from product-form (variant modal)
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {

    // Only sync if this is from product-form (variant modal submission)
    // This ensures we don't duplicate syncs from normal products
    if (event.source === 'product-form') {

      // 🛡️ DEDUPLICATION CHECK: Skip if this variant was just synced
      var variantId = event.productVariantId;
      var now = Date.now();

      if (recentlySyncedVariants[variantId]) {
        var timeSinceLastSync = now - recentlySyncedVariants[variantId];
        if (timeSinceLastSync < DEDUPE_WINDOW_MS) {
          return; // Skip this sync
        }
      }

      // Mark this variant as recently synced
      recentlySyncedVariants[variantId] = now;

      // Clean up old entries (older than DEDUPE_WINDOW_MS)
      for (var vid in recentlySyncedVariants) {
        if (now - recentlySyncedVariants[vid] > DEDUPE_WINDOW_MS) {
          delete recentlySyncedVariants[vid];
        }
      }

      syncVariantCartToExternalAPI(variantId, event.cartData);
    } else {
    }
  });

  // Function to sync cart to external API (for variant products only)
  function syncVariantCartToExternalAPI(variantId, addedItemData) {

    // Fetch fresh cart data from Shopify
    $.getJSON('/cart.js')
      .done(function (cart) {

        // Validate cart has items
        if (!cart.items || cart.items.length === 0) {
          return;
        }


        var DuckDuckURL = 'https://ddbadmin.duckduckbaby.in/api/';

        // Get customer email with multiple fallbacks (same as existing code)
        var customeremail = (typeof customerEmail !== 'undefined' ? customerEmail : null)
          || $('#p_mail').val()
          || '';



        // Sync to external API
        $.ajax({
          type: 'POST',
          url: DuckDuckURL + 'storecart',
          data: {
            data: cart.items,
            customerEmail: customeremail || null
          },
          timeout: 10000, // 10 second timeout
          beforeSend: function (xhr) {
          },
          success: function (data, textStatus, xhr) {
            if (data && data.message) {
            }
            if (data && data.status) {
            }
          },
          error: function (xhr, status, error) {

            // Optional: Could add retry logic here in the future
            if (xhr.status >= 500) {
            } else if (xhr.status >= 400) {
            }
          }
        });

        // 🆕 NEW: Also send tracking data to storeNewCartDataInCsvfile API
        // This ensures the correct product data is tracked (not main page product)
        sendVariantTrackingData(addedItemData, customeremail, DuckDuckURL);
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
      });
  }

  // Function to send tracking data for variant modal products
  // This ensures the CORRECT product data is sent (not main page product)
  function sendVariantTrackingData(addedItemData, customeremail, DuckDuckURL) {

    // ----------- Extract CORRECT product info from Shopify response -----------
    // Try multiple possible field names from Shopify response
    var producttitle = addedItemData.product_title
      || addedItemData.title
      || addedItemData.product_name
      || addedItemData.name
      || '';
    var sku = addedItemData.sku
      || addedItemData.variant_sku
      || '';
    var dynamicPrice = addedItemData.price
      ? (addedItemData.price / 100)
      : (addedItemData.final_price ? (addedItemData.final_price / 100) : 0);


    // 🆕 FALLBACK: If Shopify response doesn't have complete data, try to read from the modal form
    if (!producttitle || !sku) {

      // Find the quickadd form (variant modal form)
      var $modalForm = $('form[id*="quickadd"]').last();
      if ($modalForm.length > 0) {

        if (!producttitle) {
          var formTitle = $modalForm.find('#p_title, [id*="p_title"]').val();
          if (formTitle) {
            producttitle = formTitle;
          }
        }

        if (!sku) {
          var formSku = $modalForm.find('#p_sku, [id*="p_sku"]').val();
          if (formSku) {
            sku = formSku;
          }
        }

        if (!dynamicPrice || dynamicPrice === 0) {
          var formPrice = $modalForm.find('#p_price, [id*="p_price"]').val();
          if (formPrice) {
            // Remove commas and convert to number
            dynamicPrice = parseFloat(String(formPrice).replace(/,/g, '')) || 0;
          }
        }
      } else {
      }
    }


    // ----------- Get customer info (same as existing code) -----------
    var customername = $('#p_name').val() || '';
    var customermobileno = $('#p_phone').val() || '';
    var sessionid = $('#p_id').val() || '';
    var browserId = $('#browserID').val() || '';
    var action = "Add";


    // ----------- Browser + OS + IP detection (same as existing code) -----------

    function getBrowserInfo() {
      var ua = navigator.userAgent;
      var tem;
      var M = ua.match(/(opera|chrome|safari|firefox|edge|trident(?=\/))\/?\s*([\d\.]+)/i) || [];

      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+([\d\.]+)/g.exec(ua) || [];
        return "IE " + (tem[1] || "");
      }

      if (M[1] === "Chrome") {
        tem = ua.match(/\b(OPR|Edg)\/([\d\.]+)/);
        if (tem != null)
          return tem[1].replace("OPR", "Opera").replace("Edg", "Edge") + " " + tem[2];
      }

      M = M.length >= 3 ? M : [null, navigator.appName, navigator.appVersion, "-?"];
      tem = ua.match(/version\/([\.\d]+)/i);
      if (tem != null) M[2] = tem[1];

      return M[1] + " " + M[2];
    }

    function getDeviceOS() {
      var ua = navigator.userAgent;

      if (/windows/i.test(ua)) return "WINDOWS";
      if (/macintosh|mac os x/i.test(ua)) return "MAC";
      if (/iphone|ipad|ipod/i.test(ua)) return "IPHONE";
      if (/android/i.test(ua)) return "ANDROID";
      if (/linux/i.test(ua)) return "LINUX";

      return "UNKNOWN";
    }

    function getUserIP(callback) {
      $.get("https://api.ipify.org?format=json", function (response) {
        callback(response.ip);
      }).fail(function () {
        // If IP fetch fails, continue with unknown IP
        callback('UNKNOWN');
      });
    }

    var browserInfo = getBrowserInfo();
    var deviceOS = getDeviceOS();


    // Get IP and send tracking data
    getUserIP(function (ipAddress) {

      var os_version = browserInfo + " - " + ipAddress;
      var device_detail = deviceOS + " " + browserInfo;


      // ---------- CALL TRACKING API WITH ALL PARAMETERS ----------
      console.log('📊 [global.js - sendVariantTrackingData] Sending to storeNewCartDataInCsvfile:');
      console.log('📊 Data payload:', {
        sku: sku,
        customername: customername,
        customeremail: customeremail,
        customermobileno: customermobileno,
        sessionid: sessionid,
        action: action,
        browserId: browserId,
        producttitle: producttitle,
        price: dynamicPrice,
        channel: 'Web',
        os_version: os_version,
        device_detail: device_detail,
        cart_item: addedItemData
      });
      $.ajax({
        type: 'POST',
        url: DuckDuckURL + "storeNewCartDataInCsvfile",
        data: {
          'sku': sku,
          'customername': customername,
          'customeremail': customeremail,
          'customermobileno': customermobileno,
          'sessionid': sessionid,
          'action': action,
          'browserId': browserId,
          'producttitle': producttitle,
          'price': dynamicPrice,
          'channel': "Web",
          'os_version': os_version,
          'device_detail': device_detail,
          // Single line item from Shopify response
          'cart_item': JSON.stringify(addedItemData)
        },
        dataType: "json",
        timeout: 10000,
        success: function (res) {
        },
        error: function (xhr, status, error) {
        }
      });
    });
  }

});

//Magnifing ZOOM code (Kunal)

$(document).ready(function () {
  $('.popup_pdpimage .item-5').on('click', function () {
    // Reset image scale to original size
    $('.popup_pdpimage .zoom img').css('transform', 'scale(1)');
  });

  $('.product_media .image-magnify-none').on('click', function () {
    $('.product__media').addClass('zoom');
    let initialFingerDistance = 0;
    let initialZoom = 1;
    let prevX = 0;
    let prevY = 0;
    let prevImageX = 0;
    let prevImageY = 0;
    let moving = false;
    let isZoomed = false;
    let isSlickPaused = false;

    const $innerContainer = $('.popup_pdpimage .zoom');
    const $zoomImg = $('.popup_pdpimage .zoom img');
    const $slickNextButton = $('.slick-next, .slick-prev');

    function handleTouchStart(event) {
      if (event.originalEvent.touches.length >= 2) {
        const touch1 = event.originalEvent.touches[0];
        const touch2 = event.originalEvent.touches[1];
        initialFingerDistance = Math.hypot(touch2.clientX - touch1.clientX, touch2.clientY - touch1.clientY);
        initialZoom = parseFloat($zoomImg.css('transform').split('(')[1].split(')')[0]) || 1;
        if (!isSlickPaused) {
          $('.product__media-list').slick('slickPause');
          isSlickPaused = true;
        }
      } else if (event.originalEvent.touches.length === 1 && isZoomed) {
        moving = true;
        const touch = event.originalEvent.touches[0];
        prevX = touch.clientX;
        prevY = touch.clientY;
        prevImageX = parseInt($zoomImg.css('left')) || 0;
        prevImageY = parseInt($zoomImg.css('top')) || 0;
        if (!isSlickPaused) {
          $('.product__media-list').slick('slickPause');
          isSlickPaused = true;
        }
      }
    }

    function handleTouchMove(event) {
      if (event.originalEvent.touches.length >= 2) {
        const touch1 = event.originalEvent.touches[0];
        const touch2 = event.originalEvent.touches[1];
        const currentFingerDistance = Math.hypot(touch2.clientX - touch1.clientX, touch2.clientY - touch1.clientY);
        const scale = (currentFingerDistance / initialFingerDistance) * initialZoom;
        const originalWidth = $zoomImg[0].naturalWidth;
        const originalHeight = $zoomImg[0].naturalHeight;
        const minScale = Math.min(originalWidth / $zoomImg.width(), originalHeight / $zoomImg.height());
        $zoomImg.css('transform', `scale(${Math.max(minScale, scale)})`);
        isZoomed = scale !== 1; // Check if the image is zoomed in
      } else if (event.originalEvent.touches.length === 1 && moving) {
        const touch = event.originalEvent.touches[0];
        const deltaX = touch.clientX - prevX;
        const deltaY = touch.clientY - prevY;
        let newImageX = prevImageX + deltaX;
        let newImageY = prevImageY + deltaY;

        // Limiting movement within 300px left or right
        newImageX = Math.max(-300, Math.min(newImageX, 300));
        // Limiting movement within 300px top or bottom
        newImageY = Math.max(-300, Math.min(newImageY, 300));

        $zoomImg.css({
          left: newImageX + 'px',
          top: newImageY + 'px'
        });
        if (!isSlickPaused) {
          $('.product__media-list').slick('slickPause');
          isSlickPaused = true;
        }
      }
    }

    function handleTouchEnd(event) {
      initialFingerDistance = 0;
      moving = false;
    }

    // Double-click handling
    $zoomImg.on('dblclick', function (event) {
      // Reset image position to (0, 0) and scale to original
      $zoomImg.css({
        left: '0px',
        top: '0px',
        transform: 'scale(1)'
      });
      if (!isSlickPaused) {
        $('.product__media-list').slick('slickPause');
        isSlickPaused = true;
      }
    });

    // Reset image position and scale when slick-next button is clicked
    $slickNextButton.on('click', function () {
      $zoomImg.css({
        left: '0px',
        top: '0px',
        transform: 'scale(1)'
      });
      if (!isSlickPaused) {
        $('.product__media-list').slick('slickPause');
        isSlickPaused = true;
      }
    });

    $innerContainer.on('touchstart', handleTouchStart);
    $innerContainer.on('touchmove', handleTouchMove);
    $innerContainer.on('touchend', handleTouchEnd);
  });
});








//Previous Code for zoom Working
// $('.popup_pdpimage .item-5').on('click', function() {
//     $('.product__media').removeClass('zoom');
//   });
// $('.product_media .image-magnify-none').on('click', function() {

//    $('.product__media').addClass('zoom');
// let initialFingerDistance = 0;
// let initialZoom = 1;
// let prevX = 0;
// let prevY = 0;
// let prevImageX = 0;
// let prevImageY = 0;
// let moving = false;
// let isZoomed = false;
// let isSlickPaused = false;

// const $innerContainer = $('.popup_pdpimage .zoom');
// const $zoomImg = $('.popup_pdpimage .zoom img');
// const $slickNextButton = $('.slick-next, .slick-prev');

// function handleTouchStart(event) {
//   if (event.originalEvent.touches.length >= 2) {
//     const touch1 = event.originalEvent.touches[0];
//     const touch2 = event.originalEvent.touches[1];
//     initialFingerDistance = Math.hypot(touch2.clientX - touch1.clientX, touch2.clientY - touch1.clientY);
//     initialZoom = parseFloat($zoomImg.css('transform').split('(')[1].split(')')[0]) || 1;
//     if (!isSlickPaused) {
//       $('.product__media-list').slick('slickPause');
//       isSlickPaused = true;
//     }
//   } else if (event.originalEvent.touches.length === 1 && isZoomed) {
//     moving = true;
//     const touch = event.originalEvent.touches[0];
//     prevX = touch.clientX;
//     prevY = touch.clientY;
//     prevImageX = parseInt($zoomImg.css('left')) || 0;
//     prevImageY = parseInt($zoomImg.css('top')) || 0;
//     if (!isSlickPaused) {
//       $('.product__media-list').slick('slickPause');
//       isSlickPaused = true;
//     }
//   }
// }

// function handleTouchMove(event) {
//   if (event.originalEvent.touches.length >= 2) {
//     const touch1 = event.originalEvent.touches[0];
//     const touch2 = event.originalEvent.touches[1];
//     const currentFingerDistance = Math.hypot(touch2.clientX - touch1.clientX, touch2.clientY - touch1.clientY);
//     const scale = (currentFingerDistance / initialFingerDistance) * initialZoom;
//     $zoomImg.css('transform', `scale(${scale})`);
//     isZoomed = scale !== 1; // Check if the image is zoomed in
//   } else if (event.originalEvent.touches.length === 1 && moving) {
//     const touch = event.originalEvent.touches[0];
//     const deltaX = touch.clientX - prevX;
//     const deltaY = touch.clientY - prevY;
//     let newImageX = prevImageX + deltaX;
//     let newImageY = prevImageY + deltaY;

//     // Limiting movement within 117px left or right
//     newImageX = Math.max(-117, Math.min(newImageX, 117));
//     // Limiting movement within 117px top or bottom
//     newImageY = Math.max(-117, Math.min(newImageY, 117));

//     $zoomImg.css({
//       left: newImageX + 'px',
//       top: newImageY + 'px'
//     });   if (!isSlickPaused) {
//       $('.product__media-list').slick('slickPause');
//       isSlickPaused = true;
//     }
//   }
// }

// function handleTouchEnd(event) {
//   initialFingerDistance = 0;
//   moving = false;
// }

// // Double-click handling
// $zoomImg.on('dblclick', function(event) {
//   // Reset image position to (0, 0) and scale to original
//   $zoomImg.css({
//     left: '0px',
//     top: '0px',
//     transform: 'scale(1)'
//   });
//   // if (isSlickPaused) {
//   //   $('.product__media-list').slick('slickPlay');
//   //   isSlickPaused = false;
//   // }
//   if (!isSlickPaused) {
//     $('.product__media-list').slick('slickPause');
//     isSlickPaused = true;
//   }
// });

// // Reset image position and scale when slick-next button is clicked
// $slickNextButton.on('click', function() {
//   $zoomImg.css({
//     left: '0px',
//     top: '0px',
//     transform: 'scale(1)'
//   });
//   // if (isZoomed) {
//   //   $('.product__media-list').slick('slickPlay');
//   //   isSlickPaused = false;
//   // }
//   if (!isSlickPaused) {
//     $('.product__media-list').slick('slickPause');
//     isSlickPaused = true;
//   }
// });

// $innerContainer.on('touchstart', handleTouchStart);
// $innerContainer.on('touchmove', handleTouchMove);
// $innerContainer.on('touchend', handleTouchEnd);
// });

// $(".submit-go-cart").click(function() {
//   pushAddToCartEvent(); // Call the function to push the add to cart event
// });

$("cart-remove-button").click(function () {
  var purl = $(this).data('purl');
  var prid = $(this).data('prid');
  var name = $(this).data('name');
  var brand = $(this).data('brand');
  var variant = '';
  var category = $(this).data('category');
  var price = $(this).data('price');
  var prqt = $(this).data('prqt');
  var currency = '₹';
  smartech('dispatch', 'remove_from_Cart', {
    "purl": purl,
    "prid": prid,
    "name": name,
    "brand": brand,
    "variant": variant,
    "category": category,
    "price": price,
    "prqt": prqt,
    "currency": currency
  });
  //rmToCartEvent(); // Call the function to push the add to cart event
});

$(".icon-p").click(function () {
  $(".returnable-bg").show();
  $(".bg-body").show();
  $("body").addClass('hide-overflow');
});

$(".close-return").click(function () {
  $(".returnable-bg").hide();
  $(".bg-body").hide();
  $("body").removeClass('hide-overflow');
});

//   $(".icon-c").click(function(){
//     $(".code-bg").show();
//     $("body").addClass('hide-overflow');
//   });

// $(".close-return").click(function(){
//   $(".code-bg").hide();
//     $("body").removeClass('hide-overflow');
// });
$(".bg-body").click(function () {
  $(".returnable-bg").hide();
  $(".bg-body").hide();
  $("body").removeClass('hide-overflow');
});
$(".returnable-bg").click(function () {
  $(".returnable-bg").hide();
  $(".bg-body").hide();
  $("body").removeClass('hide-overflow');
});
// $(".code-bg").click(function(){
//   $(".code-bg").hide();
//     $("body").removeClass('hide-overflow');
// });

// $(".section-similar-popup").click(function(){
//   $(".section-similar-popup").hide();
//     $("body").removeClass('hide-overflow-view');
// });

$('.CTS_button').on('click', function () {
  //alert('hi');
  $('html, body').animate({
    scrollTop: $('.icon-total').offset().top - $('.header-wrapper').outerHeight()
  }, 500);
});

// window.addEventListener('popstate', function(event) {
//       console.log(window.location.href, 'back');
//       window.location.reload();
//       });
//Cart Tool Tip
function cartTooltip(event) {
  const clickedElement = event.target;
  const parentElement = clickedElement.closest('.gift-wrap-cart');
  if (!parentElement) return;
  const mainParentElement = parentElement.closest('cart-items');
  const popup = parentElement.querySelector('.popuptext');
  if (!popup) return;
  popup.classList.toggle("show");
  parentElement.classList.toggle("open-popup");
  if (mainParentElement) {
    mainParentElement.classList.toggle('overlflowShow');
  }
}


function cartTooltipclose(event) {
  event.stopPropagation();
  const clickedElement = event.target;
  const parentElement = clickedElement.closest('.gift-wrap-cart');
  if (!parentElement) return;
  const popup = parentElement.querySelector('.popuptext');
  if (popup) popup.classList.remove("show");
  parentElement.classList.remove("open-popup");
  const mainParentElement = parentElement.closest('cart-items');
  if (mainParentElement) {
    mainParentElement.classList.remove('overlflowShow');
  }
}


$(".pincode-popup").click(function () {
  $(".pincode-popup").hide();
  $(".new-pincode").hide();
});
$(".icon-remove").click(function () {
  // Hide all elements with the class .remove-popup
  $(".remove-bg").hide();
  $('.section-header.shopify-section-group-header-group').css('z-index', 0);
  // Show only the .remove-popup element that is a sibling of the clicked .icon-remove element
  $(this).next(".remove-bg").show();


  $('.cart__footer-wrapper').hide();
  $("body").addClass('hide-overflow');
});
$(".no-remove").click(function () {
  $(".remove-bg").hide();
  $('.cart__footer-wrapper').show();
  $('.section-header.shopify-section-group-header-group').css('z-index', 1);
  $("body").removeClass('hide-overflow');
});
$(".show-popup").click(function () {
  $(".remove-bg").hide();
  $('.cart__footer-wrapper').show();
  $("body").removeClass('hide-overflow');
});

$(".move-wishlist").click(function () {
  $(".remove-bg").hide();
  $('.show-remove').hide();

  setTimeout(function () {
    $('.move-wish').show();
  }, 5000);
});
$(document).ready(function () {
  if ((window.location.href === 'https://duckduckbaby.in/apps/wishlists')) {
    $(".view-append").addClass('wishlist-page');
  } else {
    $(".view-append").removeClass('wishlist-page');
  }
});

function logincustomerDataupdateinCartData(customername, customeremail, customermobileno) {
  // alert("hi"+customername);
  //var customername = $('#lc_name').val();
  //var customeremail = $('#lc_mail').val();
  //var customermobileno = $('#lc_phone').val();
  //alert(customermobileno);
  var DuckDuckURL = 'https://ddbadmin.duckduckbaby.in/api/';
  var browserId = localStorage.getItem('browserId');
  $.ajax({
    type: 'POST',
    url: DuckDuckURL + "updatecartDataBrowserid",
    data: { 'customername': customername, 'customeremail': customeremail, 'customermobileno': customermobileno, 'browserId': browserId },
    dataType: "json",
    async: false,
    beforeSend: function () {
      //$('.loader').show();
      //$('#check-delivery-submit').attr('disabled',true);
      //$('#check-delivery-submit').text('Please Wait...');
    },
    success: function (res) {
    },
    complete: function () {
      //$('.loader').hide();
    }
  });
}


// window.addEventListener('load', function() {
//   localStorage.removeItem('otherBrandProducts');
//   localStorage.removeItem('sameBrandProducts');
// });

$('.underline-links-hover, .full-unstyled-link, .cart-item__name').on('click', function () {
  localStorage.removeItem('otherBrandProducts');
  localStorage.removeItem('sameBrandProducts');
});

